<form [formGroup]="manageRoleForm">
    <input type="hidden" name="menuType" id="menuType" value="secure" />
    <div class="ontario-row">
        <div class="ontario-columns">
            <h3 id="pageTitle">{{'bss.admin.manageRole.mship.title' | translate }}</h3>
            <hr>
        </div>
    </div>

    <div *ngIf="appError && !appSuccess" class="ontario-row" aria-live="polite" aria-atomic="true"
        id="pageLevelMessageId" #pageMsg>
        <div class="ontario-columns">
            <div class="ontario-alert ontario-alert--error ">
                <div class="ontario-alert__header">
                    <div class="ontario-alert__header-icon">
                        <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false"
                            sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-alert-error"></use>
                        </svg>
                    </div>
                    <h2 class="ontario-alert__header-title ontario-h4">{{'bss.error' | translate}}</h2>
                </div>
                <div class="ontario-alert__body">
                    <p [innerHTML]="appErrorMessage | translate"></p>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="appSuccess && !appError" class="ontario-row" aria-live="polite" aria-atomic="true"
        id="pageLevelMessageId" #pageMsg>
        <div class="ontario-columns ontario-small-12">

            <div class="ontario-alert ontario-alert--success">
                <div class="ontario-alert__header">
                    <div class="ontario-alert__header-icon">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-alert-success"></use>
                        </svg>
                    </div>
                    <h2 class="ontario-alert__header-title ontario-h4">{{'bss.success' | translate}}:</h2>
                </div>
                <div class="ontario-alert__body">
                    <p *ngIf="successType==='sa'&&sendEmailType ==='sd'">
                      {{ 'bss.admin.manageRole.mship.message.addOrRevoke.1' | translate }} {{ userRoleDetails.role.roleName}} {{ 'bss.admin.manageRole.mship.message.addOrRevoke.2' | translate }} {{ user.displayName }}. {{ 'bss.admin.manageRole.mship.message.addOrRevoke.4' | translate }}
                    </p>
                    <p *ngIf="successType==='sa'&&sendEmailType ==='nSd'">
                        {{ 'bss.admin.manageRole.mship.message.addOrRevoke.1' | translate }} {{ userRoleDetails.role.roleName}} {{ 'bss.admin.manageRole.mship.message.addOrRevoke.2' | translate }} {{ user.displayName }}.
                      </p>

                    <p *ngIf="successType==='sr'">
                      {{ 'bss.admin.manageRole.mship.message.addOrRevoke.1' | translate }} {{ userRoleDetails.role.roleName}} {{ 'bss.admin.manageRole.mship.message.addOrRevoke.3' | translate }} {{ user.displayName }}.
                    </p>
                    <p *ngIf="successType==='swe' || successType==='sve'" [innerHTML]="appSuccessMessage | translate"></p>
                </div>
            </div>
        </div>
    </div>



    <div class="ontario-row">
        <dl><dt>
            <div class="ontario-columns ontario-small-12 ontario-medium-8">
                <label class="ontario-label" for="manageRole">
                    {{ 'bss.admin.manageRole.mship.subTitle.role' | translate }} {{ userRoleDetails.role.roleName}}
                </label>
            </div>
        </dt><dd></dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-5">
                <label class="ontario-label" for="firstName">
                    {{ 'bss.admin.manageRole.mship.label.firstName' | translate }}
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-6">
                <label id="firstName">
                    <p>{{ user.firstName }}</p>
                </label>
            </div>
        </dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-5">
                <label class="ontario-label" for="lastName">
                    {{ 'bss.admin.manageRole.mship.label.lastName' | translate }}
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-6">
                <label id="lastName">
                    <p>{{ user.lastName}} </p>
                </label>
            </div>
        </dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-5">
                <label class="ontario-label" for="displayName">
                    {{ 'bss.admin.manageRole.mship.label.displayName' | translate }}
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-6">
                <label id="displayName">
                    <p>{{ user.displayName }} </p>
                </label>
            </div>
        </dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-5">
                <label class="ontario-label" for="email">
                    {{ 'bss.admin.manageRole.mship.label.emailAddress' | translate }}
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-6">
                <label id="email">
                    <p>{{ user.email }} </p>
                </label>
            </div>
        </dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-5">
                <label class="ontario-label" for="roleAssigned">
                    {{ 'bss.admin.manageRole.mship.label.role' | translate }}
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-6">
                <label id="roleAssigned">
                    <p *ngIf="user.roleAssigned === '1'">{{ 'bss.admin.manageRole.mship.label.assigned' | translate }}
                    </p>
                    <p *ngIf="user.roleAssigned === '0'">{{ 'bss.admin.manageRole.mship.label.notAssigned' | translate
                        }} </p>
                </label>
            </div>
        </dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-5">
                <label class="ontario-label" for="otherRoles">
                    {{ 'bss.admin.manageRole.mship.label.otherRoles' | translate }}
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-6">
                <label id="otherRoles">
                    <p>{{ roles }} </p>
                </label>
            </div>
        </dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-5">
                <label class="ontario-label" for="emailConfirmed">
                    {{ 'bss.admin.manageRole.mship.label.emailConfirmed' | translate }}
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-6">
                <label id="emailConfirmed">
                    <p *ngIf="user.emailVerified === '1'">{{ 'bss.label.yes' | translate }} </p>
                    <p *ngIf="user.emailVerified === '0'">{{ 'bss.label.no' | translate }} </p>
                </label>
            </div>
        </dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-5">
                <label class="ontario-label" for="accountStatus">
                    {{ 'bss.admin.manageRole.mship.label.status' | translate }}
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-6">
                <label id="accountStatus">
                    <p *ngIf="user.accountStatus === '0'">{{ 'bss.admin.selectUserAcc.status.active' | translate }}</p>
                    <p *ngIf="user.accountStatus === '1'">{{ 'bss.admin.selectUserAcc.status.locked' | translate }}</p>
                    <p *ngIf="user.accountStatus === '2'">{{ 'bss.admin.selectUserAcc.status.expired' | translate }}</p>
                    <p *ngIf="user.accountStatus === '3'">{{ 'bss.admin.selectUserAcc.status.disabled' | translate }}</p>
                    <p *ngIf="user.accountStatus === '4'">{{ 'bss.admin.selectUserAcc.status.activeLocked' | translate }}</p>
                    <p *ngIf="user.accountStatus !== '0' && user.accountStatus !== '1' && user.accountStatus !== '2' && user.accountStatus !== '3' && user.accountStatus !== '4'">{{user.accountStatus}}</p>
                </label>
            </div>
        </dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-5">
                <label class="ontario-label" for="guid">
                    {{ 'bss.admin.manageRole.mship.label.guid' | translate }}
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-6">
                <label id="guid">
                    <p>{{ user.guid }} </p>
                </label>
            </div>
        </dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-5">
                <label class="ontario-label" for="createdDate">
                    {{ 'bss.admin.manageRole.mship.label.creationDate' | translate }}
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-6">
                <label id="createdDate">
                    <p>{{ user.createdDate }} </p>
                </label>
            </div>
        </dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-column ontario-small-18">
                <button class="ontario-button ontario-button--secondary"
                    title="{{'bss.admin.manageRole.mship.button.back.title' | translate}}" tabindex="150"
                    (click)="onBack()">
                    {{'bss.admin.manageRole.mship.button.back' | translate}}
                </button>
                <button *ngIf="user.roleAssigned === '0'" class="ontario-button"
                    [ngClass]="{'ontario-button--primary': !isSubmitting}"
                    title="{{'bss.admin.manageRole.mship.button.assignRole.title' | translate}}"
                    (keyup.enter)="assignRole()" tabindex="106" (click)="assignRole()" [disabled]="isSubmitting"
                    aria-describedby="pageLevelMessageId">
                    {{'bss.admin.manageRole.mship.button.assignRole' | translate}}
                </button>
                <button *ngIf="user.roleAssigned === '1'" class="ontario-button"
                    [ngClass]="{'ontario-button--primary': !isSubmitting}"
                    title="{{'bss.admin.manageRole.mship.button.revokeRole.title' | translate}}"
                    (keyup.enter)="revokeRole()" tabindex="107" (click)="revokeRole()" [disabled]="isSubmitting"
                    aria-describedby="pageLevelMessageId">
                    {{'bss.admin.manageRole.mship.button.revokeRole' | translate}}
                </button>
                <button *ngIf="user.roleAssigned === '1'" class="ontario-button" 
                    [ngClass]="{'ontario-button--primary': !isSubmitting}"
                    title="{{'bss.admin.manageRole.mship.button.sendWelcomeEmail.title' | translate}}"
                    tabindex="108" (click)="sendWelcomeEmail()"
                    [disabled]="isSubmitting" aria-describedby="pageLevelMessageId">
                    {{'bss.admin.manageRole.mship.button.sendWelcomeEmail' | translate}}
                </button>
                <button *ngIf="user.emailVerified === '0'" class="ontario-button" 
                    [ngClass]="{'ontario-button--primary': !isSubmitting}"
                    title="{{'bss.admin.manageRole.mship.button.sendVerificationEmail.title' | translate}}"
                    tabindex="108" (click)="sendVerificationEmail()"
                    [disabled]="isSubmitting" aria-describedby="pageLevelMessageId">
                    {{'bss.admin.manageRole.mship.button.sendVerificationEmail' | translate}}
                </button>
                <button class="ontario-button ontario-button--secondary"
                    title="{{'bss.admin.manageRole.mship.message.resetPassword.button.title' | translate}}" 
                    tabindex="109"
                    (click)="resetPassword()">
                    {{'bss.admin.manageRole.mship.message.resetPassword.button' | translate}}
                </button>
            </div>
        </dd></dl>
    </div>

    <div class="ontario-row">
        <dl><dt></dt><dd>
        <div class="ontario-column ontario-small-18">
          <button class="ontario-button ontario-button--secondary"  tabindex="110"
          title="{{ 'bss.admin.selectUserAcc.newSearch.title' | translate }}" (click)="onNewSearch()">
          {{ 'bss.admin.selectUserAcc.newSearch' | translate }}
        </button>
        </div>
    </dd></dl>
      
    </div>
</form>

<dialog class="ontario-progress" #progressDialog>
    <app-progress></app-progress>
</dialog>